import React, { useRef, useState } from "react";
import { TrashIcon } from "@heroicons/react/outline";

export default ({
    name,
    className,
    onChange,
    accept,
    errors = [],
    ...props
}) => {
    const fileInput = useRef();
    const [file, setFile] = useState(null);

    function browse() {
        fileInput.current.click();
    }

    function remove() {
        setFile(null);
        onChange(null);
        fileInput.current.value = null;
    }

    function handleFileChange(e) {
        const file = e.target.files[0];
        setFile(file);
        onChange(file);
    }

    return (
        <>
            <div className="mt-1">
                <input
                    id={name}
                    ref={fileInput}
                    accept={accept}
                    type="file"
                    name={name}
                    className="hidden"
                    onChange={handleFileChange}
                />
                {!file && (
                    <div>
                        <button
                            onClick={browse}
                            type={"button"}
                            className={
                                "inline-flex justify-center rounded-md border border-transparent bg-gray-200 py-2 px-4 text-sm font-medium shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2"
                            }
                        >
                            Browse
                        </button>
                    </div>
                )}
                {file && (
                    <div className="flex items-center justify-between p-2">
                        <div className="flex-1 pr-1">
                            {file.name}
                            <span className="ml-1 text-xs text-gray-600">
                                filesize
                            </span>
                        </div>
                        <button onClick={remove}>
                            <TrashIcon className={"h-5 w-5 text-red-600"} />
                        </button>
                    </div>
                )}
            </div>
            {errors && <div className="form-error">{errors}</div>}
        </>
    );
};
